import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en-US.json'
import zhCN from './zh-CN.json'

Vue.use(VueI18n)

const messages = {
  en,
  'zh-CN': zhCN
}

// 从浏览器或 localStorage 获取用户首选语言
const locale = localStorage.getItem('lang') || navigator.language || 'en'

export default new VueI18n({
  locale: "en",  // 设置默认语言
  fallbackLocale: 'zh-CN',  // 如果当前语言没有对应的翻译
  messages
})